module.exports = __webpack_public_path__ + "img/fitnerss dashboard.031d8713.png";